import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { ACRouterButton } from 'academy-common-lib/components/ACRouterButton';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { ALL_CONTENT_PATH, COMPLETED_CONTENT_PATH, INCOMPLETE_CONTENT_PATH } from '../../constants/routes';
import { trackViewAllClick } from '../../utils/trackingUtils';
import IncompleteAssignedContent from './IncompleteAssignedContent';
import OverviewSectionHeader from './OverviewSectionHeader';
import RecentlyCompletedAssignedContent from './RecentlyCompletedAssignedContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssignedContentOverview = () => {
  const {
    isLaptop
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(OverviewSectionHeader, {
      button: /*#__PURE__*/_jsx(ACRouterButton, {
        onClick: () => trackViewAllClick('all-assigned-content'),
        size: "small",
        to: `${ALL_CONTENT_PATH}?sortBy=CONTENT_NAME&sortOrder=ASC`,
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myTeam.overview.assignedContent.viewAll"
        })
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.assignedContent.description"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.overview.assignedContent.title"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsxs(CardGrid, {
        columns: isLaptop ? 1 : 2,
        gutterSize: 20,
        children: [/*#__PURE__*/_jsxs(CardWrapper, {
          compact: true,
          children: [/*#__PURE__*/_jsx(CardHeader, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.overview.assignedContent.recentlyCompletedContent.title"
            }),
            titleSize: "sm",
            toolbar: /*#__PURE__*/_jsx(ACRouterLink, {
              onClick: () => trackViewAllClick('recently-completed-assigned-content'),
              to: `${COMPLETED_CONTENT_PATH}?sortBy=COMPLETED_DATE&sortOrder=DESC`,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.assignedContent.recentlyCompletedContent.viewAll"
              })
            })
          }), /*#__PURE__*/_jsx(CardSection, {
            children: /*#__PURE__*/_jsx(RecentlyCompletedAssignedContent, {})
          })]
        }), /*#__PURE__*/_jsxs(CardWrapper, {
          compact: true,
          children: [/*#__PURE__*/_jsx(CardHeader, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.overview.assignedContent.incompleteContent.title"
            }),
            titleSize: "sm",
            toolbar: /*#__PURE__*/_jsx(ACRouterLink, {
              onClick: () => trackViewAllClick('incomplete-assigned-content'),
              to: `${INCOMPLETE_CONTENT_PATH}?sortBy=DUE_DATE&sortOrder=DESC&dueDate=PAST`,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.overview.assignedContent.incompleteContent.viewAll"
              })
            })
          }), /*#__PURE__*/_jsx(CardSection, {
            children: /*#__PURE__*/_jsx(IncompleteAssignedContent, {})
          })]
        })]
      })
    })]
  });
};
export default AssignedContentOverview;